import React, { useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import NotesForReceptionForm from "./NotesForReceptionForm.jsx";
import AppointmentNoteFields from "./AppointmentNotesFields";
import { useWizardContext } from "./AppointmentWizardContext";
import { WIZARD_STEPS } from "./hooks/useWizardSteps";
import { useServiceOptions } from "./flow.jsx";

const AppointmentNotesTabContent = () => {
  const { clientData, selectedServiceId, setSelectedServiceId, activeStep } =
    useWizardContext();

  const { options: serviceOptions, loading: serviceOptionsLoading } =
    useServiceOptions(clientData.id);

  const currentAppointment = useMemo(() => {
    if (!clientData?.todaysAppointments || !clientData?.currentAppointmentId)
      return null;
    return clientData.todaysAppointments.find(
      (a) => a.id === clientData.currentAppointmentId,
    );
  }, [clientData]);

  useEffect(() => {
    if (
      !serviceOptionsLoading &&
      currentAppointment?.service?.id &&
      currentAppointment.service.id !== selectedServiceId
    ) {
      setSelectedServiceId(currentAppointment.service.id);
    }
  }, [
    serviceOptionsLoading,
    currentAppointment,
    selectedServiceId,
    setSelectedServiceId,
  ]);

  const isReceptionStep = activeStep === WIZARD_STEPS.RECEPTION_NOTES;
  const isProcedureNotesStep = activeStep === WIZARD_STEPS.PROCEDURE_NOTES;

  return (
    <Box sx={{ maxWidth: 1100 }}>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            minHeight: "calc(100vh - 220px)",
            paddingBottom: 20,
          }}
        >
          {isReceptionStep && (
            <NotesForReceptionForm
              services={serviceOptions}
              appointmentId={clientData?.currentAppointmentId}
            />
          )}

          {isProcedureNotesStep && <AppointmentNoteFields />}
        </Box>
      </Box>
    </Box>
  );
};

export default AppointmentNotesTabContent;
